import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  // console.log(elemento.idPlanta, idListaP.idPlanta)
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
    {/* <tr className=''> */}
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrPlanta}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrSeccion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrEquipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.codEquipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrComponente}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrMecanismo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrAplicacion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              background: elemento.idPlanta===idListaP.idPlanta?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.descrLubricante}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

//Programacion del mecanismo seleccionado
const DetalleProg = ({elemento, handleClickidListaP}) => {
  // console.log(elemento)
  return(
    <tr className=''  onClick={(ev)=>handleClickidListaP(ev, elemento)}>
    {/* <tr className=''> */}
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.consecutivo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.puntosLub}</td>
    </tr>
  )
};

const ListaProg = ({list, handleClickidListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleProg elemento={elemento} handleClickidListaP={handleClickidListaP}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Programacion del mecanismo seleccionado

class ConfDatCar2 extends React.Component {
  state={listProg: [], idListaP: [],
    argsQuery1: `{"$unwind": "$secciones"},
    {"$unwind": "$secciones.equipos"},
    {"$unwind": "$secciones.equipos.componentes"},
    {"$unwind": "$secciones.equipos.componentes.mecanismos"},
    {$project: {_id: 1, idPlanta: "$_id",
    programacion: "$secciones.equipos.componentes.mecanismos.programacion",
      descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
      descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
      descrEquipo: '$secciones.equipos.descrEquipo', codComponente: '$secciones.equipos.componentes.codComponente',
      descrComponente: '$secciones.equipos.componentes.descrComponente',
      codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
      descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
      descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
      tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
      descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
      descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
      tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
      tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
      tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
      abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
      cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
      descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
      abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad'}},
    {"$unwind": "$programacion"},
    {$project: {_id: 1, idPlanta: "$_id", descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1,
        descrSeccion: 1, codEquipo: 1, descrEquipo: 1, codComponente: 1, descrComponente: 1, codMecanismo: 1,
        descrMecanismo: 1, descrAplicacion: 1, tipoLub: 1, descrFabricante: 1, descrLubricante: 1,
        tipoFrecuencia: 1, tipoLub: 1, tipoGrado: 1, abrevUnidadTF: 1, cantidadTotal: 1, descrUnidad: 1,abrevUnidad: 1,
        consecutivo: '$programacion.consecutivo', cantidad: '$programacion.cantidad',
        puntosLub: '$programacion.puntosLub', minutos: '$programacion.minutos', descrMetodo: '$programacion.descrMetodo', descrTarea: '$programacion.descrTarea',
        descrFrecuencia: '$programacion.descrFrecuencia', descrFrecuenciaPre: '$programacion.descrFrecuenciaPre',
        codProcedimiento: '$programacion.codProcedimiento', nombreArchivo: '$programacion.nombreArchivo', fechaProx: '$programacion.fechaProx'
      }}`  
    }
  
  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

    // console.log(idListaP)
    let argsBuscar=""
    argsBuscar += `'descrEmpresa': '${idListaP.descrEmpresa}'`
    if(idListaP.descrPlanta){
      argsBuscar += `, 'descrPlanta': '${idListaP.descrPlanta}'`
    }
    if(idListaP.descrSeccion){
      argsBuscar += `, 'descrSeccion': '${idListaP.descrSeccion}'`
    }
    if(idListaP.descrEquipo){
      argsBuscar += `, 'descrEquipo': '${idListaP.descrEquipo}'`
    }
    if(idListaP.descrComponente){
      argsBuscar += `, 'descrComponente': '${idListaP.descrComponente}'`
    }
    if(idListaP.descrMecanismo){
      argsBuscar += `, 'descrMecanismo': '${idListaP.descrMecanismo}'`
    }
    let argsBuscarPl = {}
    argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
  
    // console.log(argsBuscarPl)
    let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
    let listProg = await data.allPlantaRtes
    // console.log(listProg, idListaP)
    this.setState({listProg})
    this.setState({idListaP: idListaP})
  
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.list!==prevProps.list){
      this.setState({listProg: [], idListaP: []})
    }
  }

  render(){
    const {listProg, idListaP} = this.state;
  // console.log(list)
  //Traer autorizaciones
  // const a0101 = autorizacUA.findIndex( autorizac => autorizac === "0101" );
  // const a010101 = autorizacUA.findIndex( autorizac => autorizac === "010101" );
  
  // let list = list
  // let list1 = list1
// console.log(this.props.list)
  let list = []
  if(this.props.list){
    list = this.props.list
    for(let i=0; i<this.props.list.length; i++){
      list[i].idPlanta = i
    }
  }

  return (
    <div>
      <List selection>
        {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
        <TitDer list={this.props.list} textBoton1="Cartas de Lubricación" btnNuevo={"NO"} styles={this.props.styles}/>

        {/* <div> */}
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '50%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaEmp styles={this.props.styles} list={this.props.list1}
                    handleChange={this.props.handleChange} />
                </Form.Field>
              </div>
            </div>
          </div>
            <div style={{height: '20em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Cód equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Aplicación/Espesante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Lubricante</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
            <hr></hr>
            <div style={{height: '12em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Consec</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Método</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Tarea</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Frecuencia</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Tipo frec</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Cantidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Puntos</th>
                  </tr>
                </thead>
                <ListaProg list={listProg} handleClickidListaP={this.props.handleClickidListaP}/>
              </table>
              <p></p>
            </div>
          </div>
        {/* <Lista list={list} styles={styles} handleClickidLista={a0101!==-1?handleClickidLista:()=>{}}/> */}
      </List>
    </div>
  )
      }
};

export default compose( 
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
)(ConfDatCar2)
